import { render, staticRenderFns } from "./FormInputOption.vue?vue&type=template&id=23d04c5e&scoped=true&"
import script from "./FormInputOption.vue?vue&type=script&lang=js&"
export * from "./FormInputOption.vue?vue&type=script&lang=js&"
import style0 from "./FormInputOption.vue?vue&type=style&index=0&id=23d04c5e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d04c5e",
  null
  
)

export default component.exports